// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"f515362d","453":"ad1905fb","777":"a8b15100"}[chunkId] + ".chunk.js";
};